import { GetNeighborReportsRequest } from "../../../api";
import { NeighborPickupsList } from "../../../api/models/NeighborPickupsList";
import { getSessionCookie } from "../../../components/cookies";
import { commonSlice, store } from "../../../store";
import { setSnackbarToggled } from "../../common/common";
import { api } from "../../common/make_api";
import { setSnackbarMessage } from "../../weekly/weeklyreport";

export async function selectNeighbors(
    unladenTripSessionId: string,
    unladenStartTs: string
): Promise<NeighborPickupsList | null> {
    store.dispatch(commonSlice.actions.startLoading());
    try {
        const state = store.getState();
        if (!getSessionCookie().consoleUserPermissions.includes("neighbors")) {
            return null;
        }

        const officeId = state.common.selectedOfficeId;

        const req_nb: GetNeighborReportsRequest = {
            neighborsRequest: {
                officeId,
                unladenTripSessionId,
                unladenStartTs,
            },
        };

        const res_nb: NeighborPickupsList = await api
            .getShiftReportsAPI()
            .getNeighborReports(req_nb);

        const neighbors = res_nb.neighborReports ? res_nb.neighborReports : [];

        let errorMsg: null | string = null;

        if (neighbors.length == 0) {
            errorMsg = "情報提供期間外です。";
        }

        const _notcreated = neighbors.filter((x) => {
            return x.neighborPickupStatus == "data_not_created";
        });

        if (_notcreated.length > 0) {
            errorMsg = "データ生成前です。乗務の2日後から確認出来ます。";
        }

        // no_neighbor_pickupが一つでも存在する場合、そのMSGを優先して表示
        const _noneighbor = neighbors.filter((x) => {
            return x.neighborPickupStatus == "no_neighbor_pickup";
        });

        const _pickup = neighbors.filter((x) => {
            return x.neighborPickupStatus == "neighbor_pickup_found";
        });

        if (_noneighbor.length > 0 && _pickup.length === 0) {
            errorMsg = "他車両実績が存在しません。";
        }

        if (errorMsg) {
            setSnackbarToggled(true);
            setSnackbarMessage(errorMsg);
        }

        console.debug("Got neighbors report:", req_nb, res_nb);
        return res_nb;
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
